import * as React from 'react';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { getShopCustomers, resetData } from 'redux/modules/shop/shopcard';
import { ITranslateProps } from 'models/common';
import { dateParser, fullPhoneNumber, getCustomerTabUrl } from 'helpers/common';
import { PersonItem } from 'components';
import { Button, EllipseGreyBlackButton } from 'components/Common/Button';
import { Dispatch } from 'react-redux';
import { closeModal, showModal } from 'redux/modules/modal';
import SearchUsers from 'containers/Search/SearchUsers';
import { RouteComponentProps, browserHistory } from 'react-router';
import { ICustomer } from 'models/shop/customer';
import { PortalOneColumnLayout } from 'components/PortalStructure';

interface IParams {
	id?: string;
}

interface IProps
	extends RouteComponentProps<IParams, {}>,
		ITranslateProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps> {}

const mapStateToProps = (state: IStore) => ({
	shopCard: state.shopcard.shopcard,
	customers: state.shopcard.customers,
});

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
	resetData: () => dispatch(resetData()),
	getShopCustomers: (shopId: string, currentPage: number, clean?: boolean) =>
		dispatch(getShopCustomers(shopId, currentPage, clean)),
	showModal: (type: string, modalProps: any) => dispatch(showModal(type, modalProps)),
	closeModal: () => dispatch(closeModal()),
});

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopCustomerListComponent extends React.Component<IProps> {
	constructor(props) {
		super(props);
		this.handleViewMoreClick = this.handleViewMoreClick.bind(this);
		this.openAddCustomerModal = this.openAddCustomerModal.bind(this);
		this.handleCustomerClick = this.handleCustomerClick.bind(this);
	}

	public componentDidMount() {
		this.props.getShopCustomers(this.shopId, 1, true);
	}

	componentDidUpdate(prevProps: Readonly<IProps>): void {
		if (this.props.params.id != prevProps.params.id) {
			this.props.getShopCustomers(this.shopId, 1, true);
		}
	}

	private get shopId() {
		return this.props.params.id;
	}

	private handleViewMoreClick = () => {
		const id = this.shopId;
		const currentPage = this.props.customers.currentPage;
		if (id && currentPage) {
			this.props.getShopCustomers(id, currentPage + 1, false);
		}
	};

	private handleCustomerClick = (customer: ICustomer) => {
		browserHistory.push(`/shop/${this.props.params.id}/customer/${customer.id}${getCustomerTabUrl('default')}`);
	};

	private openAddCustomerModal() {
		this.props.showModal('AddCustomerModal', {
			type: c.NODE_TYPE_SHOP,
			closeModal: this.props.closeModal,
			modalTitle: this.props.t('User_ShopCard_AddCustomer'),
			modalSize: 'medium',
		});
	}

	render() {
		const { t, customers } = this.props;

		const areThereMoreElementsToLoad = (): boolean => {
			if (
				customers &&
				customers.totalItems > customers.items.length &&
				customers.items.length >= c.SHOPCARD_TAB_CUSTOMERS_ITEMSPERPAGE
			) {
				return true;
			}
			return false;
		};
		const headerArray = [
			'#',
			t('Orders_OrderCard_Label_Customer'),
			t('User_ShopCard_Phone'),
			t('User_ShopCard_LastVisit'),
			t('User_ShopCard_Visits'),
		];

		const renderElements = (header?: boolean): JSX.Element | JSX.Element[] | null => {
			if (header) {
				return (
					<div className="header row">
						<div className="col-1">
							<p className="bold">{headerArray[0].toUpperCase()}</p>
						</div>
						<div className="col-5">
							<p className="bold">{headerArray[1].toUpperCase()}</p>
						</div>
						<div className="col-3">
							<p className="bold">{headerArray[2].toUpperCase()}</p>
						</div>
						<div className="col-2">
							<p className="bold">{headerArray[3].toUpperCase()}</p>
						</div>
						<div className="col-1 d-flex justify-content-end">
							<p className="bold">{headerArray[4].toUpperCase()}</p>
						</div>
					</div>
				);
			} else if (customers && customers.items.length) {
				return customers.items.map((customer, index) => {
					return (
						<div className="body row pointer" key={index} onClick={() => this.handleCustomerClick(customer)}>
							<div className="col-1">
								<p className="gray">{index + 1}</p>
							</div>
							<PersonItem user={customer} className="col-5" />
							<div className="col-3">
								<p>{fullPhoneNumber(t, customer.callingCodeKey, customer.phoneNumber)}</p>
							</div>
							<div className="col-2">
								<p>{dateParser(customer.lastOrderDate)}</p>
							</div>
							<div className="col-1 d-flex justify-content-end">
								<p>{customer.numberOfOrders}</p>
							</div>
							<div className={`fade-element ${areThereMoreElementsToLoad() ? 'show' : ''}`} />
						</div>
					);
				});
			}
			return null;
		};

		return (
			<PortalOneColumnLayout>
				<Button onClick={this.openAddCustomerModal}>{t('User_ShopCard_AddCustomer')}</Button>
				<SearchUsers parentCard="shop" userType="customer" />
				<div className="customerList">
					{renderElements(true)}
					{renderElements()}
					{areThereMoreElementsToLoad() ? (
						<EllipseGreyBlackButton className="view-more-btn" onClick={this.handleViewMoreClick}>
							{t('Shop_ShopCard_ViewMoreCustomers')}
						</EllipseGreyBlackButton>
					) : null}
				</div>
			</PortalOneColumnLayout>
		);
	}
}

const ShopCustomerList = connect(mapStateToProps, mapDispatchToProps)(ShopCustomerListComponent);

export { ShopCustomerList };
